export default __webpack_public_path__ + "static/media/maticCall.a18b57b6.svg";